import { isMobile } from 'react-device-detect';

export const isDesktop = !isMobile;
export { isMobile };
